import * as React from "react";
import images from "./assets/index";

const CallToAction: React.FC = () => {
  return (
    <div className="relative bg-grayBackGround flex flex-col lg:flex-row">
      {/* Div-ul pentru imagini - ascuns pe ecrane mici */}
      <div className="w-full lg:w-[30%] relative hidden lg:block">
        <img
          src={images.imageDroneOne}
          alt="Drone One"
          className="absolute w-[259px] left-[-31px] top-[-44px]"
        />
        <img
          src={images.imageDroneTwo}
          alt="Drone Two"
          className="absolute w-[259px] bottom-[75px] left-[88px]"
        />
      </div>

      {/* Div-ul pentru text - full width pe ecrane mici */}
      <div className="w-full lg:w-[70%] flex flex-col py-10 px-5 lg:py-20 lg:pr-40">
        <div className="mb-10 text-center lg:text-left">
          <img src={images.logo} alt="Logo" className="mx-auto lg:mx-0" />
        </div>
        <div className="text-current font-ubuntu flex flex-col gap-6 lg:gap-10 text-center lg:text-left">
          <p>
            DroneDen allows users to rent drones and capture stunning aerial
            views of their surroundings. With our platform, users can easily
            browse and book a variety of drones, from beginner-friendly models
            to high-end professional drones, for their personal or business
            needs.
          </p>
          <p>
            Our platform connects renters with trusted drone owners in their
            area, providing a hassle-free booking experience and ensuring a safe
            and enjoyable drone rental experience. Whether you’re looking to
            capture aerial photos and videos, survey land, inspect
            infrastructure, or just explore the skies, our website has something
            for everyone. Join us and take your adventures to new heights!
          </p>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
